import React, { useEffect, useState } from 'react';
import { IssueService } from '../../js/issues/issueService';
import { successfulAction } from '../../js/issues/IssueActionsCtrls';
import { formatDateSpacedMD, formatTime } from '../../js/lib/filters';
import moment from 'moment';
import { IssueDeferProps } from '../../js/headersegment/interfaces';

const IssueDefer: React.FC<IssueDeferProps> = ({
  issue,
  ok,
  cancel,
  issueUpdated,
  size,
}) => {
  const [dateToManipulate, setDateToManipulate] = useState<any>();
  const [increment, setIncrement] = useState<number>(3600000);
  const [resolveByTime, setResolveByTimeUpdate] = useState<string>('');
  const [resolveByTimeUTC, setResolveByTimeUTC] = useState<string>('');

  const incrementOptions = [
    { name: '1 Hour', value: 3600000 },
    { name: '1 Hour and 15 Minutes', value: 4500000 },
    { name: '1 Hour and 30 Minutes', value: 5400000 },
    { name: '1 Hour and 45 Minutes', value: 6300000 },
    { name: '2 Hours', value: 7200000 },
    { name: '2 Hours and 15 Minutes', value: 8100000 },
    { name: '2 Hours and 30 Minutes', value: 9000000 },
    { name: '2 Hours and 45 Minutes', value: 9900000 },
    { name: '3 Hours', value: 10800000 },
    { name: '3 Hours and 15 Minutes', value: 11700000 },
    { name: '3 Hours and 30 Minutes', value: 12600000 },
    { name: '3 Hours and 45 Minutes', value: 13500000 },
    { name: '4 Hours', value: 14400000 },
    { name: '4 Hours and 15 Minutes', value: 15300000 },
    { name: '4 Hours and 30 Minutes', value: 16200000 },
    { name: '4 Hours and 45 Minutes', value: 17100000 },
    { name: '5 Hours', value: 18000000 },
    { name: '5 Hours and 15 Minutes', value: 18900000 },
    { name: '5 Hours and 30 Minutes', value: 19800000 },
    { name: '5 Hours and 45 Minutes', value: 20700000 },
    { name: '6 Hours', value: 21600000 },
  ];

  useEffect(() => {
    const now = moment.utc();
    const currentResolveByTime = moment.utc(issue.resolveByTime);
    if (now.isAfter(currentResolveByTime)) {
      setDateToManipulate(now);
      updateResolveByTime(now, increment);
    } else {
      setDateToManipulate(currentResolveByTime);
      updateResolveByTime(currentResolveByTime, increment);
    }
    return () => {
      setDateToManipulate('');
      setResolveByTimeUpdate('');
      setResolveByTimeUTC('');
    };
  }, []);

  const handleIncrementChange = (value: number) => {
    setIncrement(value);
    updateResolveByTime(dateToManipulate, value);
  };

  const updateResolveByTime = (getDate: moment.MomentInput, incrementTime: number) => {
    const newResolveByTime = moment(getDate)
      .add(incrementTime, 'ms')
      .format();
    const newResolveByTimeUTC = moment
      .utc(getDate)
      .add(incrementTime, 'ms')
      .format();

    setResolveByTimeUpdate(newResolveByTime);
    setResolveByTimeUTC(newResolveByTimeUTC);
  };

  const handleOk = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const data = await IssueService.defer([{ id: issue.id, tripId: issue.tripId }], resolveByTimeUTC);
      if (successfulAction(data)) {
        issueUpdated({
          tripId: issue.tripId as string,
          issueId: issue.id!,
        });
      }
      ok();
    } catch (error) {
      console.error("Error deferring issue:", error);
    }
  };

  return (
    <>
      <div
        className={`issue-resolution-modal modal-dialog modal-${size || 'md'}`}
      >
        <form name="form" noValidate onSubmit={handleOk}>
          <div className="title">
            DEFER AN ISSUE
            <a onClick={cancel}>
              <i
                id="modalCancelled"
                className="cancel pull-right glyphicon icon-white glyphicon-remove"
              ></i>
            </a>
          </div>

          <div className="content">
            <div className="choices">
              <div className="row">
                <div className="col-md-3 fs-label fs-label-hxs fs-label-margin hidden-sm hidden-xs">
                  DEFER LENGTH
                </div>
                <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
                  DEFER LENGTH
                </div>
                <div className="col-md-6">
                  <select
                    className="form-control btn btn-default dropdown-toggle"
                    value={increment}
                    onChange={e => handleIncrementChange(Number(e.target.value))}
                  >
                    {incrementOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row field-sep">
                <div className="col-md-2"></div>
                <div className="col-md-8 center">
                  The new resolve-by time will be{' '}
                  {formatDateSpacedMD(resolveByTime)} at{' '}
                  {formatTime(resolveByTime)}.
                </div>
                <div className="col-md-2"></div>
              </div>
            </div>

            <div className="action">
              <button
                id="modalSubmitted"
                className="btn btn-default button-action"
                disabled={!increment}
              >
                DEFER
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default IssueDefer;
